import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import ContentPage from './pages/ContentPage';

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hjem" element={<Home />} />
        <Route path="/foto" element={<GalleryPage />} />
        <Route path="/galleri" element={<GalleryPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/:slug" element={<ContentPage />} />
        <Route path="/fmemailverification/:slug" element={<ContentPage />} />
        {/* Fallback for sub-paths if any */}
        <Route path="/aktiviteter/:slug" element={<ContentPage />} />
        <Route path="/om-os/:slug" element={<ContentPage />} />
      </Routes>
    </HelmetProvider>
  );
}

export default App;
